import { useSupportedCdnIntegrationsQuery } from "@modules/cdn/shared/queries.generated"
import { isProperlyConnected } from "@modules/site/cdnIntegrations"

export const useConnectedCDN = (siteId: string) => {
  const { loading, data, error } = useSupportedCdnIntegrationsQuery({
    variables: { siteId },
    fetchPolicy: "cache-and-network",
  })

  const vendor = data?.supportedCDNIntegrations?.find(isProperlyConnected)

  return { vendor: vendor?.vendor, loading, error }
}
